import React from "react";
import Moment from "moment";
import { Typography } from "antd";
import { DATE_FORMAT, DATETIME_FORMAT } from "../utils/i18n-js";

const { Text } = Typography;

const DateTime = (props) => {
    const value = props.value;
    let format;
    if (props.formatDate) {
        format = DATE_FORMAT;
    } else if (props.formatDateTime) {
        format = DATETIME_FORMAT;
    } else {
        format = props.format ? props.format : DATETIME_FORMAT;
    }

    if (value) {
        return <Text>{Moment(value).format(format)}</Text>;
    } else {
        return <></>;
    }
};

export default DateTime;
